import React, { useContext } from "react";
import PaymentContext from "../../store/PaymentContext";
import { PaymentConst } from "../../utils/payment";
import { EditOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";

interface IProps {
  isShowTab: boolean;
}

const TabBar: React.FC<IProps> = ({ isShowTab }) => {
  const {
    setTabActiveStep1,
    tabActiveStep1,
    setModalCustomer,
    currentStep,
    isMobile,
  }: any = useContext(PaymentContext);
  const router = useRouter();
  const { customer } = useContext(PaymentContext);

  return (
    <div className={`heading ${isMobile && router.pathname === '/carts' ? "carts_tab-bar-mobile" : ""}`}>
      <div className='px-4 m-auto flex justify-between w-full'>
        <div className='carts_tab-bar'>
          {isShowTab &&
            PaymentConst.TabList.map(
              (item: { label: string; value: string }) => {
                return (
                  <div
                    key={item.value}
                    className={`${item.value == tabActiveStep1 ? "carts_tab_bar-active" : ""
                      }`}
                    onClick={() => setTabActiveStep1(item.value)}
                  >
                    {item.label}
                  </div>
                );
              }
            )}
        </div>
        {/*{*/}
        {/*    customer?.name && (*/}
        {/*        <div className="carts-profile">*/}
        {/*            <img*/}
        {/*                src="/asset/icon/icon_avatar.svg"*/}
        {/*                width={20}*/}
        {/*                height={20}*/}
        {/*                alt="avatar"*/}
        {/*            />*/}
        {/*            <div className={`carts_profile-address ${ currentStep != 1 ? 'carts_profile-address-lg' : '' }`}>*/}
        {/*                {`${ customer.name }, ${ customer.phone }, ${ customer.email }, ${ customer.address }`}*/}
        {/*            </div>*/}
        {/*            /!*<div*!/*/}
        {/*            /!*    className="flex items-center justify-center"*!/*/}
        {/*            /!*    onClick={() => {*!/*/}
        {/*            /!*        setModalCustomer({*!/*/}
        {/*            /!*            open: true,*!/*/}
        {/*            /!*            type: 'customer'*!/*/}
        {/*            /!*        });*!/*/}
        {/*            /!*    }}*!/*/}
        {/*            /!*>*!/*/}
        {/*            /!*    <div className="bg-white h-6 px-2 flex items-center rounded cursor-pointer">*!/*/}
        {/*            /!*        <EditOutlined /> <span className="carts_profile-text-action">Chỉnh sửa thông tin</span>*!/*/}
        {/*            /!*    </div>*!/*/}
        {/*            /!*</div>*!/*/}
        {/*        </div>*/}
        {/*    )*/}
        {/*}*/}
      </div>
    </div>
  );
};

export default TabBar;
